export default __webpack_public_path__ + "static/minecraft-main-green-366d75cf0e8372a46e99ce3e2bdf2f67.jpg";